<template>
  <div class="attribution-lozenge">
    <img class="attribution-lozenge__logo" :src="src" v-if="src"/> 
    <serato-logo class="attribution-lozenge__logo attribution-lozenge__logo--serato" v-else/>   
  </div>
</template>
<script setup lang="ts">
import SeratoLogo from '@/assets/SeratoLogo.svg'
import { GallerySource } from '@/store/gallery/types'
import { computed } from 'vue'

const pexelAttributionSrc = 'https://static.serato.com/visualizer/images/PexelsLogo.png'

const props = defineProps<{
  attribution: GallerySource
}>()

const src = computed(() => props.attribution !== 'serato' ? pexelAttributionSrc : '')

</script>
<style lang="scss">
.attribution-lozenge {
  height: 30px;
  width: 70px;
  padding: 4px;
  background-color: $grey-90;
  border-radius: 2px;
  display: flex;

  &__logo {
    width: 100%;
    margin-top: auto;
    margin-bottom: auto;

    &--serato {
      height: 15px;
    }
  }
}
</style>